import React from "react"
import { latest as API_URL } from "../../../config/api";
import { isActiveSlide, positionLeft } from "../../../config/Helpers";

//Modulos
import General from "./views/General";
import FutureReserves from "./views/FutureReserves";
import AdvanceBooking from "./views/AdvanceBooking";
import FiltersActive from "./../../../components/FiltersActive";
const postUrlLogin = API_URL + "widgets";

class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            response_request : [],
            request_status   : "hide",
            active_slide: { key: "general", index: 0 },
            touch_values: {
                start: 0,
                end: 0
            },
            slides: {
                0: {
                    key: "general", index: 0
                },
                1: {
                    key: "future_reserves", index: 1
                },
                2: {
                    key: "advance_booking", index: 2
                },
                3: {
                    key: "adr", index: 2
                }
            },
            min_slide: 1,
            max_slide: 3,
            moving_touch : 0,
            tab_submodule : 'inactive',
            tab_filters : 'inactive'    
        }
        this.getResetValues = this.getResetValues.bind(this);
    }
    getResetValues(){
        return {
            response_request : [],
            request_status   : "hide",
            active_slide: { key: "general", index: 0 },
            min_slide : 1,
            max_slide : 2,
            tab_submodule : 'inactive',
            tab_filters : 'inactive'  
        }
    }
    setDefaultValuesModule(){
        let $self = this;
        this.setState({
            response_request : [],
            tab_submodule : 'inactive',
            tab_filters : 'inactive'
        }, $self.props.app.mainRequest())
    }
    activeSlide(slide) {
        this.setState(function (prev) {
            if (prev.activeSlide !== slide.key) {
                return {
                    active_slide: slide
                }
            }
        })
    }

    moveStart(touchStartEvent) {
        let self = this;
        let start_touch = touchStartEvent.targetTouches[0].clientX
        self.setState({
            touch_values: {
                start: start_touch
            }
        })
        setTimeout(() => {
            self.setState({
                touch_values: {
                    start: 0
                }
            })
        }, 500);
    }
    moveEnd(touchEndEvent) {
        const start_touch = this.state.touch_values.start;
        const end_touch = touchEndEvent.changedTouches[0].clientX;
        const difference = Math.abs(start_touch - end_touch);

        if(start_touch !== 0){
            if (difference > 200) {
                if (start_touch > end_touch) {
                    if (this.state.max_slide > this.state.active_slide.index) {
                        const slide_number = this.state.active_slide.index + 1;
                        const active_slide = this.state.slides[slide_number];
                        this.activeSlide(active_slide)
                    }
                } else {
                    if (this.state.min_slide <= this.state.active_slide.index) {
                        const slide_number = this.state.active_slide.index - 1;
                        const active_slide = this.state.slides[slide_number];
                        this.activeSlide(active_slide)
                    }
                }
            }
        }
    }
    activeSubmoduleTab() {
        this.setState(function(){
            const state = (this.state.tab_submodule === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : state,
                tab_filters : 'inactive'
             }
        })
    }
    activeFiltersTab() {
        this.setState(function(){
            const state = (this.state.tab_filters === 'active') ? 'inactive' : 'active';
            return { 
                tab_submodule : 'inactive',
                tab_filters : state
             }
        })
    }
    componentWillReceiveProps(props) {
        let response    = props.app.state.leadtime_response_request
        this.setState({
            response_request : response,
        })
    }
    render() {
        return (
            <div className="layout">
                <div className={"loading-panel " + this.state.request_status + " " + (this.props.app.state.panel !== "lead-time" ? "hide" : "")}>
                    <div className="bkg-stars">
                        <span className="figure-1"></span>
                    </div>
                </div>
                <div style={positionLeft(0, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "general", "main-slide")}>
                    <General
                        request_status={this.state.request_status}
                        panel={this.props.app.state.panel}
                        current_slide={this.state.active_slide.key}
                        response_request={this.state.response_request}
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        view_results={this.props.app.state.view_results}
                    />
                </div>
                <div style={positionLeft(1, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "future_reserves", "main-slide")}>
                    <FutureReserves
                        request_status={this.state.request_status}
                        panel={this.props.app.state.panel}
                        current_slide={this.state.active_slide.key}
                        response_request={this.state.response_request}
                        view_results={this.props.app.state.view_results}
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                    />
                </div>
                <div style={positionLeft(2, this.state.active_slide.index)} className={"slide " + isActiveSlide(this.state.active_slide.key, "advance_booking", "main-slide")}>
                    <AdvanceBooking
                        request_status={this.state.request_status}
                        panel={this.props.app.state.panel}
                        current_slide={this.state.active_slide.key}
                        response_request={this.state.response_request}
                        current_year={this.props.app.state.current_year}
                        past_year={this.props.app.state.past_year}
                        view_results={this.props.app.state.view_results}
                    />
                </div>
                <div className={"slide-keys " + (this.props.app.state.panel !== "lead-time" ? "hide" : "") + " " + this.props.app.state.status_sidebar}>
                    <div className="tabs">
                        <div className={this.state.tab_submodule} onClick={this.activeSubmoduleTab.bind(this)}>DASHBOARDS</div>
                        <div className={this.state.tab_filters + this.props.app.hasFilters()} onClick={this.activeFiltersTab.bind(this)}>FILTERS</div>
                    </div>
                    <div className={"filters-tab " + this.state.tab_filters}>
                        <FiltersActive 
                            app={this.props.app} 
                            ref={(FiltersActive) => { this._FiltersActive = FiltersActive; }}
                        />
                    </div>
                    <div className={"content-submodules " + this.state.tab_submodule}>
                        <div className={isActiveSlide(this.state.active_slide.key, "general")} onClick={this.activeSlide.bind(this, { key: "general", index: 0 })}>
                            <span className="title">GENERAL</span>
                            <span className="section"></span>
                        </div>
                        <div className={isActiveSlide(this.state.active_slide.key, "future_reserves")} onClick={this.activeSlide.bind(this, { key: "future_reserves", index:1 })}>
                            <span className="title">RESERVES</span>
                            <span className="section"></span>
                        </div>
                        <div className={isActiveSlide(this.state.active_slide.key, "advance_booking")} onClick={this.activeSlide.bind(this, { key: "advance_booking", index: 2})}>
                            <span className="title">BOOKING WINDOW</span>
                            <span className="section"></span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Layout



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/Layout.js